<span class="badge {{ chipConfig.class }}">
  <span class="badge-dot"></span>
  <span>{{ chipConfig.title }}</span>
</span>
